import React, { useMemo, useCallback } from 'react';
import { getCurrentUser, signOut } from '../../../api/auth';
import List, { ListTypes } from 'devextreme-react/list';

import './UserMenuSection.scss';
import type { UserMenuSectionProps } from '../../../types';
import { useTranslation } from 'react-i18next';

type MenuItem = {
  text: string;
  icon: string;
  onClick: () => void;
};

export const UserMenuSection = ({ showAvatar, listRef }: UserMenuSectionProps) => {
  const user = getCurrentUser();
  const {t} = useTranslation();
  const handleSignOut = useCallback(() => {
    signOut();
    window.location.reload();
  }, []);
  const menuItems = useMemo<MenuItem[]>(
    () => [
      {
        text: t("logout"),
        icon: '',
        onClick: handleSignOut,
      },
    ],
    [t, handleSignOut]
  );

  const listElementAttr = {
    class: 'user-info-list'
  };

  const onItemClick = useCallback(({ itemData }: ListTypes.ItemClickEvent<MenuItem>) => itemData?.onClick(), []);

  return (
    <>
      <div className='user-info'>
        { showAvatar && (
          <div className='image-container'>
            <div
              style={{
                backgroundImage: `url(${user?.avatarUrl})`,
              }}
              className='user-image'
            />
          </div>
        )}
        <div className='user-name'>{user?.name || user?.email || ''}</div>
      </div>
      <List ref={listRef} elementAttr={listElementAttr} onItemClick={onItemClick} items={menuItems} />
    </>
  );
};
